"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThirdStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../../../ui");
var _Actions = require("./Actions");
var _excluded = ["totpKey", "onPrevStepClick", "onNextStepClick"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var P = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 23px;\n"])));
var ThirdStep = function ThirdStep(_ref) {
  var totpKey = _ref.totpKey,
    onPrevStepClick = _ref.onPrevStepClick,
    onNextStepClick = _ref.onNextStepClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, _extends({}, props, {
    className: "d-flex flex-column flex-grow-1"
  }), /*#__PURE__*/_react.default.createElement(P, {
    className: "text-center"
  }, t('setUpAuthenticatorThirdStep.restoreKey')), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.CopyInputGroupAddon, {
    value: totpKey,
    addonType: "append"
  }), /*#__PURE__*/_react.default.createElement(_ui.CopyInput, {
    value: totpKey
  }))), /*#__PURE__*/_react.default.createElement(P, {
    className: "text-center"
  }, t('setUpAuthenticatorThirdStep.contactOurSupport')), /*#__PURE__*/_react.default.createElement(_Actions.Actions, {
    className: "mt-auto",
    prevBtnProps: {
      onClick: onPrevStepClick
    },
    nextBtnProps: {
      onClick: onNextStepClick
    }
  }));
};
exports.ThirdStep = ThirdStep;